import { brandBackdrop, LOGIN_TINT } from '~/helpers/branding/brand-backdrop'

/**
 * Fond de la page de connexion, derrière la carte (#79).
 *
 * Le motif de marque partagé (`brand-backdrop.ts`), à pleine intensité : aucun
 * texte n'y est posé — le formulaire vit sur la carte opaque —, donc aucun
 * contraste n'est à garantir sur ces couleurs de marque.
 *
 * ⚠️ Le contenu doit être positionné (`relative`) : sinon ce calque, lui en
 * `absolute`, se peint par-dessus.
 *
 * Affiché dès `sm`, le seuil où le conteneur ouvre sa marge (`sm:p-12`) et
 * laisse voir ce qui entoure la carte — et non `md`, celui de l'aside : entre
 * les deux, la marge montrait un aplat gris. En dessous, la carte occupe tout
 * l'écran et le fond ne se verrait pas.
 */
function LoginBackdrop({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex h-dvh w-full items-center justify-center overflow-hidden bg-muted/40 p-0 sm:p-12">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 hidden sm:block"
        style={{ background: brandBackdrop(LOGIN_TINT) }}
      />
      {children}
    </div>
  )
}

export default LoginBackdrop
